export default "__VITE_ASSET__CDXLOhd4__"